@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.container {
  display: flex;
  gap: 8px;
  background: var(--white);
  height: 110px;
}

.content {
  position: relative;
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
}

.time {
  @include sm-sohne-semi;
  color: var(--dark-80);
  letter-spacing: 0.56px;
  line-height: 130%;
}

.status {
  align-self: flex-start;
}

.previewSection {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.imageContainer {
  position: relative;
  height: 100%;
  aspect-ratio: 1;
  overflow: hidden;
  border-radius: 8px;
  flex-shrink: 0;
  width: 110px;

  &.empty {
    background: var(--dark-4);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &.textPreview {
    box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.15), 0.5px 0.5px 0px 0px rgba(255, 255, 255, 0.2) inset;
  }
}

.image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.emptyPreviewText {
  font-size: 13px;
  color: var(--dark-40);
}

.text {
  @include line-clamp(3);
  @include sm-sohne;
  color: var(--dark-60);
}

.emptyCaptionContainer {
  display: flex;
  align-items: center;
  gap: 8px;
}

.emptyCaptionText {
  font-size: 13px;
  color: var(--dark-40);
}

.channelIndicator {
  position: absolute;
  bottom: 0px;
  right: 2px;
  padding: 4px;
  border-radius: 4px;
  z-index: 10;
}

.textPreviewContainer {
  width: 110px;
  height: 110px;
  min-width: 110px;
  min-height: 110px;
  padding: 6px;
  border-radius: 4px;
}

.textPreview {
  height: 98px;
  color: var(--dark-100);
  background-color: var(--light-100);
  align-items: flex-start;
  overflow: hidden;
  font-size: 8px;
  font-weight: 500;
}

.loadingStateOverlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
}

.progressBar {
  width: 60%;
  height: 4px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 2px;
  overflow: hidden;
}

.progress {
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 2px;
  transition: width 0.3s ease;
}

.skeletonLoader {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.skeletonLine {
  height: 12px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite;
  border-radius: 6px;
}

.skeletonLine:nth-child(1) {
  width: 85%;
}

.skeletonLine:nth-child(2) {
  width: 80%;
}

.skeletonLine:nth-child(3) {
  width: 85%;
}

@keyframes skeleton-loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.hidden {
  display: none;
}

.textContent {
  flex: 1;
  width: 100%;
  min-height: 0;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}
